import { memo } from "react";
import type { StatusCardProps } from "@cointervue/shared/types/commonTypes";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@cointervue/design-system/components";

function StatusCard({
  icon,
  value,
  label,
  candidatesStatusWeeklyCount,
  color = "text-brand-green",
}: StatusCardProps) {
  return (
    <Card className="p-2 w-full md:w-[22%]">
      <div className="flex flex-col items-start space-y-1 ">

        <CardHeader className="flex-row w-full p-0 justify-between items-center">
          <div className="p-2 rounded-lg bg-brand-light-orange-2">
            <img src={icon} alt="StatusCardIcon" className="w-3 h-3" />
          </div>
          <CardTitle className="mr-3">{value}</CardTitle>
        </CardHeader>

        <CardContent className="p-0">
          <CardDescription className="text-wrap font-medium text-[10px] mt-2">
            {label}
          </CardDescription>
        </CardContent>

        {candidatesStatusWeeklyCount && !candidatesStatusWeeklyCount.includes("+0") && (
          <CardFooter className={`font-medium text-sm p-0 ${color}`}>
            {candidatesStatusWeeklyCount}
          </CardFooter>
        )}
      </div>
    </Card>
  );
}

export default memo(StatusCard);